export default {"src":"/_next/static/media/icone-helio.62871e79.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};